import styled from 'styled-components'
import { Panel } from '../styles'

export const LoftPanel = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;
  overflow-x: hidden;
  overflow-y: scroll;

  @media (min-width: 1200px) {
    padding-top: 10px;
  }

  strong {
    font-weight: 600;
  }
`

export const ConstructionPanel = styled(Panel)`
  margin-top: 30px;
`

export const SelectionHeader = styled.p`
  color: #000;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: 500;
  margin-top: 15px;
  margin-bottom: 0px;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;

  button {
    text-transform: unset;
  }
`

export const Checkmark = styled.i`
  padding-right: 10px;
`
